import React from 'react';

const EmergencyToolbox: React.FC = () => {
  return (
    <div>
      <div className="flex justify-center p-10">
        <iframe
          src="https://trello.com/b/RNA1zSan.html"
          width="1860"
          height="898"
          frameBorder="0"
          title="Emergency Toolbox Trello Board"
        ></iframe>
      </div>
    </div>
  );
};

export default EmergencyToolbox;
